import { Module } from 'vuex';
import { IRootState, client } from '@/store';
import { IBankAttribute, IPageParams, ICRUDResponse } from '@/models';

export interface IBankAttributeState {
  entities: Record<string, IBankAttribute>;
  currentPage: number[];
  pageParams: Partial<IPageParams>;
}

export const bankAttribute: Module<IBankAttributeState, IRootState> = {
  namespaced: true,
  state: {
    entities: {},
    currentPage: [],
    pageParams: {
      per_page: 15,
    }
  },
  actions: {
    getEntities({ commit }) {
      client
        .get<ICRUDResponse<IBankAttribute[]>>('bank_attributes')
        .then(({ data: { data, ...pageParams } }) => {
          commit('setEntities', data);
          commit('setPageParams', pageParams);
        });
    },
    getEntity({ commit }, id) {
      client
        .get<ICRUDResponse<IBankAttribute>>(`bank_attributes/${id}`)
        .then(({ data }) => {
          commit('setEntities', data);
        });
    },
    createEntity({ dispatch }, entity: Omit<IBankAttribute, 'id'>) {
      return client
        .post('bank_attributes', entity)
        .then(({ data }) => {
          dispatch('getEntities')
          return data
        });
    },
    deleteEntity({ dispatch }, entity: IBankAttribute) {
      return client
        .delete(`bank_attributes/${entity.id}`)
        .then(() => dispatch('getEntities'));
    },
    updateEntity({ dispatch }, entity: IBankAttribute) {
      return client
        .put(`bank_attributes/${entity.id}`, entity)
        .then(({ data }) => {
          dispatch('getEntities')
          return data
        });
    },
  },
  mutations: {
    setEntities(state, datum: IBankAttribute | IBankAttribute[]) {
      const entities = Array.isArray(datum) ? datum : [datum];
      state.entities = entities.reduce(
        (acc, item) => ({ ...acc, [item.id]: item }),
        {},
      );
      state.currentPage = entities.map((entity) => entity.id);
    },
    setPageParams(
      state,
      pageParams: Omit<ICRUDResponse<IBankAttribute[]>, 'data'>,
    ) {
      state.pageParams = pageParams;
    },
  },
  getters: {
    entitiesSlice({ currentPage, entities }) {
      return currentPage.map((id) => entities[id]);
    },
  },
};
